import apiConfig from '@core/app-config/api-config'

export const quillToolbar = [
  [{ font: [] }],
  [{ size: [] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ header: 1 }, { header: 2 }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ align: [] }],
  ['blockquote', 'code-block'],
  ['link', 'image', 'photo-archive', 'video'],
  ['clean'],
]

export function buildQuillOptions(overrides = {}) {
  const {
    startId = null,
    requireStartPick = false,
  } = overrides

  return {
    theme: 'snow',
    modules: {
      toolbar: {
        container: quillToolbar,
        handlers: {
          'photo-archive': () => {},
        },
      },
      imageUpload: {
        uploadUrl: `${apiConfig.host}/file/upload`,
      },
      photoArchiveInsert: {
        startId,
        requireStartPick,
        includeStartInShortcode: overrides.includeStartInShortcode ?? requireStartPick,
      },
      photoShortcodePreview: {
        startId,
      },
    },
  }
}

export const defaultQuillOptions = buildQuillOptions()
